import script from "./AppMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMain.vue?vue&type=script&setup=true&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=1ebe216e&lang=less&scoped=true"
script.__scopeId = "data-v-1ebe216e"

export default script